
import './App.css';
import Header from './Pages/Header';
import Footer from './Pages/Footer';
import Firstpage from './Pages/Firstpage';
import Secondpage from './Pages/Services';
import Thirdpage from './Pages/Projects';
import Fourthpage from './Pages/Portfolio';
import Fifthpage from './Pages/Company';
import {
  BrowserRouter as Router,
  Routes,
  Route,

} from "react-router-dom";
function App() {
  return (
    <>
      <Router>
        <Header />
        <Routes>
          <Route exact path='/' element={<Firstpage />} />
          <Route exact path="/Firstpage" element={<Firstpage />} />
          <Route exact path="/Secondpage" element={<Secondpage />} />
          <Route exact path="/Thirdpage" element={<Thirdpage />} />
          <Route exact path="/Fourthpage" element={<Fourthpage />} />
          <Route exact path="/Fifthpage" element={<Fifthpage />} />
        </Routes>
      </Router>
      <Footer />
    </>
  )
}

export default App;
